import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/Home'
import Header from '@/components/Header'
import HelloWorld from '@/components/HelloWorld'
import Product from '@/Product'
import About from '@/About'
import News from '@/News'
import NewsDetail from '@/components/NewsDetail'
import Video from '@/Video'
import VideoDetail from '@/components/VideoDetail'
import Contact from '@/Contact'
import Cart from '@/Cart'
import Plan from '@/Plan'
import ProductDetail from '@/components/ProductDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/header',
      name: 'Header',
      component: Header
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/plan',
      name: 'Plan',
      component: Plan
    },
    {
      path: '/helloworld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/product/:key',
      name: 'ProductS',
      component: Product
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/newsdetail/:id',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/video',
      name: 'Video',
      component: Video
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/videodetail/:id',
      name: 'VideoDetail',
      component: VideoDetail
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/product/:id',
      name: 'ProductC',
      component: Product
    },
    {
      path: '/productdetail/:id',
      name: 'Productdetail',
      component: ProductDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js